import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { trimStart } from 'lodash';
import { SyntheticEvent, useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import useCheckbookConfiguration from 'src/hooks/useCheckbookConfiguration';
import { getBgColor } from 'src/utils/icons';

const FormatCell = (props: GridCellProps) => {
  const { dataItem, onChange, dataIndex, field } = props;
  const { format = '' } = dataItem;

  const { isPageEditable, areFormatsRequired } = useCheckbookConfiguration();
  const errors: string[] = Object.values(dataItem.errors || {}).flat() as string[];
  const warnings: string[] = Object.values(dataItem.warnings || {}).flat() as string[];
  const hasError = !!errors.length;

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field,
        syntheticEvent: e as unknown as SyntheticEvent,
        value: trimStart(String(e.value)),
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase
      title={trimStart(format).toUpperCase()}
      {...props}
      className={getBgColor(errors, warnings)}
    >
      {isPageEditable && areFormatsRequired ? (
        <>
          <TextInput
            value={trimStart(format)}
            onChange={handleChange}
            valid={!hasError}
            placeholder="Enter Format"
            className="[&>input]:uppercase"
          />
        </>
      ) : (
        <span>{format}</span>
      )}
    </GridCellBase>
  );
};

export default FormatCell;
